var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGsfClose = function SvgGsfClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gsf-close_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsf-close_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "m12 13.054-5.073 5.073a.72.72 0 0 1-.522.212.7.7 0 0 1-.531-.212.72.72 0 0 1-.218-.527q0-.31.218-.527L10.947 12 5.874 6.927a.73.73 0 0 1-.213-.522.7.7 0 0 1 .213-.532.72.72 0 0 1 .526-.217q.31 0 .527.217l5.074 5.073 5.073-5.073a.72.72 0 0 1 .522-.212.7.7 0 0 1 .531.212q.218.217.218.527a.72.72 0 0 1-.218.527L13.054 12l5.073 5.073q.209.208.213.522a.7.7 0 0 1-.213.532.72.72 0 0 1-.526.217.72.72 0 0 1-.527-.217z"
  }))));
};
export default SvgGsfClose;